import React from "react";
import gameformation from '../../assets/NBA-Game-formation.svg';



const RulesAndScoring = (props) => {
   // console.log(props?.contestData)
    const scoring_rule_type = (props?.contestData && props?.contestData?.contestDetails[0]?.score_type_code) ? props?.contestData?.contestDetails[0]?.score_type_code : 'S'
    return (
        <div className="lineupscore-container">
            <h4>All games offered by Fantasy Sports Knockout use standardized lineups and scoring</h4>
            <div className="game-formation-wrap"><img alt="game information" src={gameformation} /></div>
            <div className="scoring-info-wrap">
                <div className="score-data">
                    <h5>{scoring_rule_type === 'S' ? 'STANDARD' : 'PAR'}</h5>
                    <div className="score-card-block">
                        <div className="card-wrap">
                            <div className="score-card">
                                <div className="score"><p>Points</p><p className="value">1 Pt</p></div>
                                <div className="score"><p>Assists</p><p className="value">{scoring_rule_type === 'S' ? '1.5' : '1'} Pts</p></div>
                                <div className="score">
                                    <p>Rebounds 
                                       
                                    </p>
                                    <p className="value">{scoring_rule_type === 'S' ? '1.5' : '1'} Pt</p>
                                </div>
                               
                            </div>
                        </div>
                        {scoring_rule_type === 'S' ? <div className="card-wrap">
                            <div className="score-card">
                                <div className="score"><p>Turnovers</p><p className="value">-1 Pt</p></div>
                                <div className="score"><p>Blocks</p><p className="value">3 Pts</p></div>
                                <div className="score"><p>Steals</p><p className="value">3 Pts</p></div>
                            </div> 
                        </div>: ''}
                    </div>
                </div>
               
            </div>
        </div>
    )

    
}

export default RulesAndScoring;
